<template>
  <a-card :bordered="false" title="流量数据" :headStyle="{fontSize:'18px'}">
    <div><span class="side">实时流量数据 </span> 更新时间: {{ now }}</div>
    <a-row class="row-style">
      <a-col :span="5">
        <div class="head-info"><span>浏览量</span>
          <p>{{ todayData.scanNumber }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>访客数</span>
          <p>{{ todayData.visitorNumber }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>新访客</span>
          <p>{{ todayData.newVisitorNumber }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>平均停留时间</span>
          <p>{{ todayData.avgTime }}</p></div>
      </a-col>
    </a-row>
    <div>
      <span class="side">流量总览数据</span>
      <span class="right-title">
      <a-button :class="{ isActive:isChange === 1}" style="border:0;" @click="getDays(1)">昨日</a-button>
      <a-button :class="{ isActive:isChange === 7}" style="border:0;" @click="getDays(7)">近7天</a-button>
      <a-button :class="{ isActive:isChange === 30}" style="border:0;" @click="getDays(30)">近30天</a-button>
      <span>
        <a-range-picker
          :disabledDate="disabledDate"
          :placeholder="['开始时间', '结束时间']"
          format="YYYY-MM-DD"
          :value="value"
          style="margin-right:12px;"
          :mode="mode"
          @calendarChange="handlePanelChange"
          @change="handleChange"
          @openChange="openChange"
        />
      </span>
    </span>
    </div>
    <a-row class="row-style">
      <a-col :span="5">
        <div class="head-info"><span>浏览量</span>
          <p>{{ pandectData.scanNumber }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>访客数</span>
          <p>{{ pandectData.visitorNumber }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>新访客</span>
          <p>{{ pandectData.newVisitorNumber }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>平均停留时间</span>
          <p>{{ pandectData.avgTime }}</p></div>
      </a-col>
    </a-row>
    <a-row>
      <div class="line-title">{{ titleHeader }}商品访客数</div>
      <div id="v-container" v-if='showChart'>
        <v-chart :forceFit="true" :height="500" :data="lineData" :padding="padding">
          <v-legend :position="position"/>
          <v-tooltip crosshairs="y"></v-tooltip>
          <v-axis></v-axis>
          <v-line position="date*value" color="type"></v-line>
        </v-chart>
      </div>
    </a-row>
  </a-card>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DataFlow',
  data() {
    return {
      titleHeader: '昨日',
      isChange: 1,
      now: '',
      lineData: [],
      todayData: {
        scanNumber: 0,
        visitorNumber: 0,
        newVisitorNumber: 0,
        avgTime: '00:00'
      },
      pandectData: {
        scanNumber: 0,
        visitorNumber: 0,
        newVisitorNumber: 0,
        avgTime: '00:00'
      },
      todayTime: '',
      endTime: '',
      startTime: '',
      startValue: '',
      position: 'top-right',
      showChart: false,
      padding: [40, 20, 80, 50],
      mode: ['date', 'date'],
      value: []
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.showChart = true
      this.today(),
        this.getDays(1)
    })
  },
  methods: {
    moment,
    handleChange(value) {
      this.value = value
    },
    handlePanelChange(value) {
      this.startValue = value[0]._d
      if (value[0] && value[1]) {
        this.startTime = moment(value[0]._d).format('YYYY-MM-DD')
        this.endTime = moment(value[1] ? value[1]._d : null).format('YYYY-MM-DD')
        this.isChange = -1
        this.titleHeader = ''
        this.getMerchantFlowStatistic()
      }
    },
    //禁选开始时间前后各31天
    disabledDate(current) {
      let days = moment().endOf('day').valueOf()
      if (current.valueOf() > days - 3600000 * 24) {
        return true
      }
      return current._d.getTime() > new Date(this.startValue).getTime() + 8.64e7 * 31 || current._d.getTime() < new Date(this.startValue).getTime() - 8.64e7 * 31
    },
    openChange(open) {
      if (!open) {
        this.startValue = ''
      }
    },
    //获取今天时间
    today() {
      var now = moment().subtract('days', 0).format('YYYY-MM-DD HH:mm:ss ')
      var today = moment().subtract('days', 0).format('YYYY-MM-DD')
      this.todayTime = today
      this.now = now
      this.getFlowRealData()
      this.getLogUtils().logWithTag('今天时间', this.todayTime)
    },
    //获取昨日、近7天、近30天开始结束时间
    getDays(value) {
      var endTime = moment(new Date().getTime() - 3600 * 24 * 1000).format('YYYY-MM-DD')
      var startTime = moment().subtract('days', value).format('YYYY-MM-DD')
      this.startTime = startTime
      this.endTime = endTime
      this.value = null
      if (value == 30) {
        this.titleHeader = '近30天'
        this.isChange = value
      } else if (value == 7) {
        this.titleHeader = '近七天'
        this.isChange = value
      } else {
        this.titleHeader = '昨日'
        this.isChange = value
      }
      this.getMerchantFlowStatistic()
      this.getLogUtils().logWithTag('startDate', this.startTime)
      this.getLogUtils().logWithTag('endDate', this.endTime)
    },
    //获取实时流量数据
    getFlowRealData() {
      this.getHttpServices().getUserService().post('api/v2/statistics/getMerchantFlowRealTime', {
        specificDay: this.todayTime
      }).then(res => {
        this.todayData = res
        this.getLogUtils().logWithTag('实时流量数据', res)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //获取总览流量数据
    getMerchantFlowStatistic() {
      this.getHttpServices().getUserService().post('api/v2/statistics/getMerchantFlowStatistic', {
        endDay: this.endTime,
        startDay: this.startTime
      }).then(res => {
        this.pandectData = res
        this.lineData = res.itemList
        this.getLogUtils().logWithTag('总览流量数据', res)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>
<style lang="less">
.isActive {
  color: #40a9ff;
}

.side {
  padding-left: 10px;
  line-height: 18px;
  font-size: 16px;
  border-left: 1px solid cornflowerblue;
}

.row-style {
  padding: 20px;
  border-radius: 3px;
  margin: 15px 0;
  border: 1px solid #d5d5d5;
}

.line-title {
  margin: 50px 0 20px 10px;
  font-size: 14px;;
}

.right-title {
  position: absolute;
  right: 20px;
}

.head-info {
  position: relative;
  text-align: left;
  padding: 0 32px 0 0;
  min-width: 125px;

  span {
    color: rgba(0, 0, 0, .45);
    display: inline-block;
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 4px;
  }

  p {
    color: rgba(0, 0, 0, .85);
    font-size: 24px;
    line-height: 32px;
    margin: 0;
  }
}
</style>
